import { RouteConfig } from 'src/routing/types'

const ROUTE: RouteConfig = {
  name: 'help-center',
  path: ({ topicSlug }: { topicSlug?: string }) =>
    `/help-center${topicSlug ? `/topics/${topicSlug}` : ''}`,
}

export default ROUTE
